<template>
  <el-select
    :filterable="filterable"
    :multiple="multiple"
    collapse-tags
    :value="options.length > 0 ? value : undefined"
    :placeholder="placeholder"
    :clearable="clearable"
    @change="onChange"
  >
    <el-option
      v-for="item in items"
      :key="item.value"
      :label="item.text"
      :value="valueType === 'object' ? item : item.value"
      v-tooltip="item.text"
    />
  </el-select>
</template>

<script>
export default {
  name: "CsSelect",
  props: {
    value: {
      required: false,
      default: undefined,
    },
    filterable: {
      type: Boolean,
      required: false,
      default: false,
    },
    valueType: {
      type: String,
      required: false,
      default: "onlyValue", // onlyValue-change时只返回value字段，object-返回的值是带有value,text的对象
    },
    items: {
      type: [Array, Function],
      required: false,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  computed: {
    options() {
      if (Array.isArray(this.items)) {
        return this.items;
      } else {
        return [];
      }
    },
    valueKey() {
      return this.valueType === "object" ? "value" : undefined;
    },
  },
  methods: {
    onChange(val) {
      if (this.multiple) {
        // 处理clearable时的""和默认时undefind
        const value = Array.isArray(val) ? val : [];
        this.$emit("input", value);
        this.$emit("change", value);
      } else {
        // 处理clearable时的""和默认时undefind
        const value = val === "" ? undefined : val;
        this.$emit("input", value);
        this.$emit("change", value);
      }
    },
  },
};
</script>
